import React, { createContext, useContext, useState, useEffect } from "react";
import formatDateBD from "../utils/formatarDataBD";

const AgendaCareContext = createContext(null);

const FILTROS_STORAGE_KEY = "agenda_care_filtros";

function filtrosPadrao() {
  const hoje = new Date();
  return {
    situacao: "",
    hora: "",
    enfermeiroId: "",
    cliente: null,
    dataInicial: formatDateBD(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
    dataFinal: formatDateBD(hoje),
  };
}

function carregarFiltrosIniciais() {
  const padrao = filtrosPadrao();

  try {
    const raw = sessionStorage.getItem(FILTROS_STORAGE_KEY);
    if (!raw) return padrao;

    const parsed = JSON.parse(raw);
    const cliente = parsed.clienteId
      ? {
          id: parsed.clienteId,
          nome: parsed.clienteNome || "",
          cpf: parsed.clienteCpf || "",
        }
      : null;

    return {
      situacao: parsed.situacao || "",
      hora: parsed.hora || "",
      enfermeiroId: parsed.enfermeiroId ? String(parsed.enfermeiroId) : "",
      cliente,
      dataInicial:
        parsed.dataInicial !== undefined
          ? parsed.dataInicial || null
          : padrao.dataInicial,
      dataFinal:
        parsed.dataFinal !== undefined
          ? parsed.dataFinal || null
          : padrao.dataFinal,
    };
  } catch {
    return padrao;
  }
}

function salvarFiltros(filtros) {
  try {
    sessionStorage.setItem(
      FILTROS_STORAGE_KEY,
      JSON.stringify({
        situacao: filtros.situacao || "",
        hora: filtros.hora || "",
        enfermeiroId: filtros.enfermeiroId || "",
        clienteId: filtros.cliente?.id ?? "",
        clienteNome: filtros.cliente?.nome || "",
        clienteCpf: filtros.cliente?.cpf || "",
        dataInicial: filtros.dataInicial,
        dataFinal: filtros.dataFinal,
      })
    );
  } catch {
    // sessionStorage indisponível
  }
}

export const AgendaCareProvider = ({ children }) => {
  const [aba, setAba] = useState(0);
  const [filtros, setFiltros] = useState(carregarFiltrosIniciais);

  const setSituacao = (situacao) => {
    setFiltros((prev) => ({ ...prev, situacao }));
  };

  const setHora = (hora) => {
    setFiltros((prev) => ({ ...prev, hora }));
  };

  const setEnfermeiroId = (enfermeiroId) => {
    setFiltros((prev) => ({ ...prev, enfermeiroId }));
  };

  const setDataInicial = (valor) => {
    setFiltros((prev) => ({ ...prev, dataInicial: valor || null }));
  };

  const setDataFinal = (valor) => {
    setFiltros((prev) => ({ ...prev, dataFinal: valor || null }));
  };

  const setCliente = (cliente) => {
    setFiltros((prev) => ({ ...prev, cliente: cliente || null }));
  };

  useEffect(() => {
    salvarFiltros(filtros);
  }, [filtros]);

  return (
    <AgendaCareContext.Provider
      value={{
        aba,
        setAba,
        situacao: filtros.situacao,
        setSituacao,
        hora: filtros.hora,
        setHora,
        enfermeiroId: filtros.enfermeiroId,
        setEnfermeiroId,
        cliente: filtros.cliente,
        setCliente,
        dataInicial: filtros.dataInicial,
        setDataInicial,
        dataFinal: filtros.dataFinal,
        setDataFinal,
      }}
    >
      {children}
    </AgendaCareContext.Provider>
  );
};

export const useAgendaCareContext = () => {
  const context = useContext(AgendaCareContext);
  if (!context) {
    throw new Error("useAgendaCareContext deve ser usado dentro de AgendaCareProvider");
  }
  return context;
};
